import React, { useState, useRef, useEffect } from "react";
import SearchSvg from "../../../../assets/images/lupa-purple.svg";
import "./Search.scss";

const Search = ({ text, setText, placeholder, onEnter }) => {
  const [isFocused, setFocus] = useState(false);
  const inputEl = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setFocus(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (isFocused) {
      inputEl.current.focus();
    }
  });

  const changeFocus = () => {
    if (!isFocused) {
      setFocus(true);
    }
  };

  const handleKeyPress = (e) => {
    if (onEnter && e.key === "Enter") {
      console.log("keyPress");
      onEnter();
    }
  };

  return (
    <div className="search-container">
      <img src={SearchSvg} alt="logo-busqueda" />
      <input
        value={text}
        onChange={setText}
        placeholder={placeholder}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
};

export default Search;
